import { Box, ComponentTrackingType, Flex, Icon, Link, Text, useTheme } from '@homebotapp/hb-react-component-catalog'
import { ReactNode } from 'react'

export interface RowMenuItemProps {
  icon: ReactNode
  label: ReactNode | string
  rightElement?: ReactNode
  onClick?: () => void
  tracking?: ComponentTrackingType
}

export const RowMenuItem = ({ icon, label, rightElement, onClick, tracking }: RowMenuItemProps) => {
  const { theme } = useTheme()
  return (
    <Link color='neutral.800' onClick={onClick} tracking={tracking}>
      <Flex
        flexDirection='row'
        gap={4}
        background={theme.isLightThemeType ? 'neutral.300' : 'neutral.200'}
        minHeight='72px'
        alignItems='center'
        justifyContent='space-between'
        px={4}
      >
        <Flex flex={1} alignItems='center'>
          {icon && <Box>{icon}</Box>}
          {typeof label === 'string' ? (
            <Text size='sm' color='neutral.900' fontWeight={500} m={0} ml='16px'>
              {label}
            </Text>
          ) : (
            <>{label}</>
          )}
        </Flex>

        <Flex alignItems='center' justifyContent='flex-end' gap='8px'>
          <Icon name='angle-right' width='4' height='4' color='primary.700' />
          {rightElement && rightElement}
        </Flex>
      </Flex>
    </Link>
  )
}
